import React from "react";
import TextInput from "../../../components/TextInput";
import SearchButton from "../../../components/SearchButton";
import RefreshButton from "../../../components/RefreshButton";

const TableFilters = ({
  setIsSearching,
  setFilterText,
  moduleDetails,
  textInputName,
  disabledButton,
  isFromRecent,
  setIsResetFromRecent,
  filterText,
}) => {
  return (
    <div>
      <div className="flex flex-row space-x-2">
        <TextInput
          type={textInputName}
          name={textInputName}
          value={filterText}
          placeholder={moduleDetails}
          onChange={(e) => {
            const value = e ? e.target.value : "";
            setFilterText(value);
          }}
        />

        <SearchButton
          buttonValue="Search"
          className={
            filterText === "" || disabledButton ? "opacity-50" : "opacity-100"
          }
          disabled={filterText === "" || disabledButton ? true : false}
          onClick={() => {
            setIsSearching(true);
          }}
        />
        <div>
          <RefreshButton
            className={
              isFromRecent
                ? "opacity-100"
                : filterText === "" || disabledButton
                ? "opacity-50"
                : "opacity-100"
            }
            disabled={
              isFromRecent
                ? false
                : filterText === "" || disabledButton
                ? true
                : false
            }
            onClick={() => {
              if (!disabledButton) {
                setFilterText("");
              }
              if (isFromRecent) {
                setIsResetFromRecent(true);
              }
              setIsSearching(false);
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default TableFilters;
